import React, { useState } from "react";
import "./WaitlistModal.css";

function WaitlistModal({ isOpen, onClose, buttonType = "waitlist" }) {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Simulate submission (you can integrate with a service later)
    // For now, we'll just store it in localStorage and show success
    try {
      // Get existing emails from localStorage
      const existingEmails = JSON.parse(
        localStorage.getItem("waitlistEmails") || "[]"
      );

      // Add new email with timestamp
      const newEntry = {
        email: email,
        type: buttonType,
        timestamp: new Date().toISOString(),
      };

      existingEmails.push(newEntry);

      // Save to localStorage
      localStorage.setItem("waitlistEmails", JSON.stringify(existingEmails));

      // Debug log to verify it saved
      console.log("Email saved to localStorage:", newEntry);
      console.log("Total emails in localStorage:", existingEmails.length);

      // You can also send to a service here
      // Example with Formspree (free service):
      // await fetch('https://formspree.io/f/YOUR_FORM_ID', {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify({ email, type: buttonType })
      // });

      setTimeout(() => {
        setIsLoading(false);
        setIsSubmitted(true);
      }, 1000);
    } catch (error) {
      console.error("Error submitting email:", error);
      setIsLoading(false);
      alert("There was an error. Please try again.");
    }
  };

  const handleClose = () => {
    setEmail("");
    setIsSubmitted(false);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="waitlist-modal-overlay" onClick={handleClose}>
      <div className="waitlist-modal" onClick={(e) => e.stopPropagation()}>
        <button className="waitlist-modal-close" onClick={handleClose}>
          ×
        </button>

        {!isSubmitted ? (
          <>
            <div className="waitlist-icon">🚀</div>
            <h2 className="waitlist-modal-title">Join the Waitlist</h2>
            <p className="waitlist-modal-text">
              Be the first to know when M31-V1 launches. We're building
              something extraordinary.
            </p>

            <form onSubmit={handleSubmit} className="waitlist-form">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
                className="waitlist-input"
                disabled={isLoading}
              />
              <button
                type="submit"
                className="waitlist-submit-btn"
                disabled={isLoading}
              >
                {isLoading ? "Joining..." : "Join Waitlist"}
              </button>
            </form>

            <p className="waitlist-note">
              We respect your privacy. Unsubscribe at any time.
            </p>
          </>
        ) : (
          <div className="waitlist-success">
            <div className="success-icon">✓</div>
            <h2 className="waitlist-modal-title">You're on the list!</h2>
            <p className="waitlist-modal-text">
              Thank you for your interest. We'll notify you as soon as we
              launch.
            </p>
            <button onClick={handleClose} className="waitlist-done-btn">
              Done
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default WaitlistModal;
